import Nullstack from 'nullstack';
export default function IconVectorBezier2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vector-bezier-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "17",
    y: "17",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "5",
    x2: "14",
    y2: "5"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "19",
    x2: "17",
    y2: "19"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "19",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "5",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5"
  }), " ");
}